import OptionValueResource from '../optionValue'
import { DefaultInput, DefaultFormAutocomplete } from './index'

export default {
    tin: new DefaultInput('Tax ID'),
    ext_payroll_id: new DefaultInput('Ext Payroll'),
    status: new DefaultInput('Status'),

    // personal info
    first_name: new DefaultInput('First Name'),
    last_name: new DefaultInput('Last Name'),
    middle_name: new DefaultInput('Middle Name'),
    alt_name: new DefaultInput('Alt Name'),
    email: new DefaultInput('E-mail'),
    status: new DefaultInput('Status'),
    birth_date: new DefaultInput('Birth Date'),
    mobile_phone: new DefaultInput('Phone Number'),
    second_phone: new DefaultInput('Second Phone Number'),
    gender_id: new DefaultInput('Gender'),
    marital_status_id: new DefaultInput('Marital Status'),
    citizenship_id: new DefaultInput('Citizenship'),
    ethnicity_id: new DefaultFormAutocomplete('Ethnicity', OptionValueResource, 'ethnicity_id'),
    exemptions: new DefaultInput('Exemptions'),
    main_address1: new DefaultInput('Main Address1'),
    main_address2: new DefaultInput('Main Address2'),
    main_city: new DefaultInput('Main City'),
    main_state_id: new DefaultInput('Main State'),
    main_postal: new DefaultInput('Main Postal'),
    main_country_id: new DefaultInput('Main Country'),

    // mailing info
    mailing_address1: new DefaultInput('Mailing Address1'),
    mailing_address2: new DefaultInput('Mailing Address2'),
    mailing_city: new DefaultInput('Mailing City'),
    mailing_state_id: new DefaultInput('Mailing State'),
    mailing_postal: new DefaultInput('Mailing Postal'),
    mailing_country_id: new DefaultInput('Mailing Country'),

    // loanout info
    loanout_status: new DefaultInput('Loanout Status'),
    loanout_name: new DefaultInput('Loanout Name'),
    loanout_ein: new DefaultInput('Loanout Ein'),
    loanout_owner: new DefaultInput('Loanout Owner'),
    loanout_owner_title: new DefaultInput('Loanout Owner Title'),
    loanout_states_registered: new DefaultInput('Loanout States Registered'),
    loanout_address1: new DefaultInput('Loanout Address1'),
    loanout_address2: new DefaultInput('Loanout Address2'),
    loanout_city: new DefaultInput('Loanout City'),
    loanout_state_id: new DefaultInput('Loanout State'),
    loanout_postal: new DefaultInput('Loanout Postal'),
    loanout_country_id: new DefaultInput('Loanout Country'),
    loanout_type_id: new DefaultInput('Loanout Type'),
    loanout_exception_id: new DefaultInput('Loanout Exception'),
    exemptions_state: new DefaultInput('Exemptions State'),
    special_type: new DefaultInput('Special Type'),
    special_type_properties: new DefaultInput('Special Type Properties'),

    // w4 info
    w4_exempt: new DefaultInput('W4 Exempt'),
    w4_job_count: new DefaultInput('W4 Job Count'),
    w4_children: new DefaultInput('W4 Children'),
    w4_other_dependents: new DefaultInput('W4 Other Dependents'),
    w4_dependent_adj: new DefaultInput('W4 Dependent Adj'),
    w4_other_income: new DefaultInput('W4 Other Income'),
    w4_deductions: new DefaultInput('W4 Deductions'),
    w4_extra_wh: new DefaultInput('W4 Extra WH'),
    state_extra_wh: new DefaultInput('State Extra WH'),
    alien_no: new DefaultInput('Alien Number'),
    ethnicity_other: new DefaultInput('Ethnicity Other'),
    state_forms: new DefaultInput('State Forms'),
    state_form_fields: new DefaultInput('State Form Fields'),
    er_gender_id: new DefaultInput('ER Gender'),
    er_ethnicity_id: new DefaultInput('ER Ethnicity'),

    // propay info
    propay_id: new DefaultInput('Propay Id'),
    main_address_propay_id: new DefaultInput('Main Address Propay'),
    mailing_address_propay_id: new DefaultInput('Mailing Address Propay'),
    w4_propay_id: new DefaultInput('W4 Propay Id'),
    ach_propay_ids: new DefaultInput('ACH Propay Ids'),
    loanout_address_propay_id: new DefaultInput('Loanout Address Propay Id'),
    agent_address_propay_id: new DefaultInput('Agent Address Propay Id'),
}
